import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchPredesTransactionsObject from '../../api/PredesTransactionsObjectAPI';
import { PREDES_TRANSACTIONS_OBJECT_REQUEST } from '../actions/types/PredesTransactionsObjectActionsTypes';
import { postPredesTransactionsObjectSuccessActionCreator, postPredesTransactionsObjectFailureActionCreator } from '../actions/PredesTransactionsObjectActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doPredesTransactionsObjectWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsObject, action.payload);
    yield put(postPredesTransactionsObjectSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.transaction.object.success'),
    }));
  } catch (error) {
    yield put(postPredesTransactionsObjectFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doPredesTransactionsObjectWatcher() {
  yield takeLatest(PREDES_TRANSACTIONS_OBJECT_REQUEST, doPredesTransactionsObjectWorker);
}

export default doPredesTransactionsObjectWatcher;
